import BtnMint from '../images/btn_mint.png';
import { useSelector } from "react-redux";

export default function Generation(props) {
  const data = useSelector((state) => state.data);

  return (
    <>
      {/* <div className="generation">
        <h4 className="generation__title">Generation 0</h4>
        <p className="generation__count">{Number.parseInt(data.gen0Supply) > Number.parseInt(data.totalSupply) ? data.totalSupply : data.gen0Supply}/{data.gen0Supply}</p>
        <div className='soldout' style={{ visibility: Number.parseInt(data.gen0Supply) >= Number.parseInt(data.totalSupply) ? 'hidden':"visible"}}>
          <p className='soldout__inner'>SOLD OUT</p>
        </div>
      </div> */}
      <div className="generation">
        <h4 className="generation__title">Generation 1 - 0.5</h4>
        <p className="generation__count">{Number.parseInt(data.gen0Supply) >= Number.parseInt(data.totalSupply) ? 0 : Number.parseInt(data.totalSupply) - Number.parseInt(data.gen0Supply)}</p>
        <div className='soldout' style={{ visibility: Number.parseInt(data.totalSupply) !== 0 && Number.parseInt(data.totalSupply) >= Number.parseInt(data.maxSupply) ? 'visible' : "hidden" }}>
          <p className='soldout__inner'>SOLD OUT</p>
        </div>
      </div>
    </>
  );
}
